import { get } from 'lodash';

import { CoverPhoto } from '@components/Article';
import {
  getArticleUrl,
  getCoverPhotoAlt,
  getLiveStatus,
  getPremiumStatus,
} from '@lib/article/getters';
import { Link } from '@lib/navigation';

interface SearchResultPostProps {
  // TODO: Figure out the type of search result post.
  post: any;
}
export default function SearchResultPost({ post }: SearchResultPostProps) {
  const highlightText = get(post, 'highlight.content', []);
  const highlightSubtitle = get(
    post,
    'highlight.postBeforeContentAnalyzed',
    [],
  );
  const highlightTags = get(post, 'highlight.tags', []);
  const highlightTitle = get(post, 'highlight.postTitle[0]', post.postTitle);
  return (
    <Link href={getArticleUrl(post)}>
      <div className="search-page__post pointer">
        <div
          className="search-page__post_title"
          dangerouslySetInnerHTML={{ __html: highlightTitle }}
        />
        <div className="search-page__post_body">
          <div className="grid grid-cols-4">
            <div>
              <CoverPhoto
                isLive={getLiveStatus(post)}
                isPremium={getPremiumStatus(post)}
                isZoomable={true}
                postType={post.postType}
                imgUrl={post.postFeaturedImageThumb}
                alt={getCoverPhotoAlt(post)}
              />
            </div>
            <div className="col-span-3">
              <div
                className="search-page__post_text"
                dangerouslySetInnerHTML={{
                  __html: [...highlightText, ...highlightSubtitle].reduce(
                    (acc, item) => `${acc ? acc + '[...]' : ''}${item}`,
                    '',
                  ),
                }}
              />
              <div className="search-page__post_tags">
                {highlightTags.map((tag) => (
                  <span dangerouslySetInnerHTML={{ __html: tag }} />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
}
